

  $(document).ready(function(){
    $('#custom-opty-var').on('click', function() {
     
      $('#side-drawer').addClass('open');
    });

    $('.close-drawer').on('click', function() {
      $('#side-drawer').removeClass('open');
    });
    $('.side-drawer .variant-image-option input').on('change', function () {
      if ($(this).is(':checked')) {
        $('.side-drawer').removeClass('open');
      }
    });
    $('.overlay-right').on('click', function() {
          $('.side-cart-drawer').removeClass('open');
        });
      
        $(document).on('click', function(e) {
          if (!$(e.target).closest('#side-drawer, #custom-opty-var').length) {
            $('#side-drawer').removeClass('open');
          }
        });

        $('.opt-btn').on('change', function () {
      if ($(this).is(':checked')) {
        $('.side-cart-drawer').removeClass('open');
      }
    });

  });



document.addEventListener('DOMContentLoaded', function() {
  // Hover effect for variant images
  const variantOptions = document.querySelectorAll('.variant-image-option');
  
  variantOptions.forEach(option => {
    option.addEventListener('mouseenter', function() {
      const defaultImg = this.querySelector('.variant-default-img');
      const hoverImg = this.querySelector('.variant-hover-img');
      if (hoverImg) {
        defaultImg.style.opacity = '0';
        hoverImg.style.opacity = '1';
      }
    });
    
    option.addEventListener('mouseleave', function() {
      const defaultImg = this.querySelector('.variant-default-img');
      const hoverImg = this.querySelector('.variant-hover-img');
      if (hoverImg) {
        defaultImg.style.opacity = '1';
        hoverImg.style.opacity = '0';
      }
    });
  });
});


$(document).ready(function() {
  // Function to get selected variant data
  function getSelectedVariantData() {
    const $selected = $('.variant-image-option input[type="radio"]:checked').closest('.variant-image-option');
    
    if ($selected.length) {
      return {
        variantId: $selected.data('variant-id'),
        variantName: $selected.find('.js-value').text().trim(),
        imageSrc: $selected.find('.variant-default-img').attr('src'),
        hoverImageSrc: $selected.find('.variant-hover-img').attr('src') || null
      };
    }
    return null;
  }
  // Function to update the displayed variant info
  function updateVariantDisplay(selectedVariant) {
    if (selectedVariant) {    
      $('#selected-variant-name').text(selectedVariant.variantName);      
      const $imageContainer = $('.image-side img');
      $imageContainer.attr('src', selectedVariant.imageSrc); 
    }
  }

  // Initialize on page load
  const initialVariant = getSelectedVariantData();
  console.log("Initial selection:", initialVariant);
  updateVariantDisplay(initialVariant);

  // Update when selection changes
  $('.variant-image-option input[type="radio"]').change(function() {
    const selectedVariant = getSelectedVariantData();
    console.log("Selection changed:", selectedVariant);
    const selectedOption1 = $(`.the-var-selector option[value="${selectedVariant.variantId}"]`).attr('data-option1');
    const selectedOption2 = $(`.the-var-selector option[value="${selectedVariant.variantId}"]`).attr('data-option2');
    // setTimeout(()=>{
    //   $(`.js-product-form input[name="id"]`).attr('value', selectedVariant.variantId);
    // $(`.js-product-form input[name="id"]`).val(selectedVariant.variantId);
    // },200);
    // $(`.opt-btn []`).
    console.log('selected', selectedOption1, selectedOption2)
    updateVariantDisplay(selectedVariant);
  });
});


// ring-drawer

  document.addEventListener('DOMContentLoaded', function () {
    const trigger = document.getElementById('custom-opty-ring');
    const drawer = document.getElementById('sizeDrawer');
    const closeBtn = document.getElementById('closeDrawer');

    if (trigger && drawer && closeBtn) {
      trigger.addEventListener('click', function () {
        drawer.classList.add('open');
      });

      closeBtn.addEventListener('click', function () {
        drawer.classList.remove('open');
      });

      // Optional: Close when clicking outside the drawer
      document.addEventListener('click', function (e) {
        if (!drawer.contains(e.target) && !trigger.contains(e.target)) {
          drawer.classList.remove('open');
        }
      });
    }
  });


$(".overlay-right").on('click', function(event){
   $(".rytdrawer ").removeClass("open");
});

$(".overlay-right").on('click', function(event){
   $(".side-drawer ").removeClass("open");
});


  $(document).ready(function() {
    $(".tab-content").hide();
    $(".tab-content:first").show();
    $(".tabs li:first").addClass("active");

    $(".tabs li").click(function() {
      var tabId = $(this).data('tab');
      $(".tabs li").removeClass("active");
      $(".tab-content").hide();

      $(this).addClass("active");
      $("#" + tabId).show();
    });
  });




$(".meta_accordions_item_heading").click(function () {
  $(this).toggleClass("open").next().slideToggle("fast");
  $(this)
    .parent()
    .siblings()
    .find(".meta_accordions_item_heading")
    .removeClass("open")
    .next()
    .slideUp("fast");
});

  document.addEventListener('DOMContentLoaded', function () {
    const slider = document.querySelector('.slider__grid');
    const items = slider.querySelectorAll('.slider__item');
    const dots = document.querySelectorAll('.slider__dot');

    const updateDots = () => {
      const activeItem = slider.querySelector('.slider__item.is-active');
      if (!activeItem) return;

      const activeIndex = activeItem.getAttribute('data-dot-index');

      dots.forEach(dot => {
        dot.classList.toggle('is-active', dot.getAttribute('data-dot-index') === activeIndex);
      });
    };

    // Optional: hook this into your slider events
    const observer = new MutationObserver(updateDots);
    items.forEach(item => observer.observe(item, { attributes: true, attributeFilter: ['class'] }));

    // Optionally, update on dot click (if you support that)
    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        const index = dot.getAttribute('data-dot-index');
        items.forEach(item => {
          item.classList.toggle('is-active', item.getAttribute('data-dot-index') === index);
        });
        updateDots();
      });
    });
  });

$(document).on('change', '.opt-btn.is-unavailable', function () {
$('.opt-btn').on('change', function() {
  if ($(this).is(':checked')) {
    $('.rytdrawer').removeClass('open');
  }
});
 
});
$(document).ready(function() {
  $('.opt-btn').on('change', function() {
    if ($(this).is(':checked')) {
      $('.rytdrawer').removeClass('open');
    }
  });
});


// document.addEventListener('DOMContentLoaded', () => {
//   const left   = document.querySelector('.media-gallery .sticky-content-container');
//   const right  = document.querySelector('.product-column-right');
//   if (!left || !right) return;

//   const EXTRA  = 400;
//   const SCROLL_TRIGGER = 400;

//   function recalcHeights() {
//     const leftH = left.offsetHeight;
//     right.style.minHeight = (leftH + EXTRA) + 'px';
//   }

//   function toggleScrollClass() {
//     // console.log("📏 scrollY:", window.scrollY, "| trigger:", SCROLL_TRIGGER);
//     if (window.scrollY >= SCROLL_TRIGGER) {
//       right.classList.add('scrolled-past');
//       // console.log("✅ Class added");
//     } else {
//       right.classList.remove('scrolled-past');
//       // console.log("❌ Class removed");
//     }
//   }
//   recalcHeights();
//   toggleScrollClass();

//   window.addEventListener('resize', () => {
//     recalcHeights();
//     toggleScrollClass();
//   });

//   window.addEventListener('scroll', toggleScrollClass, { passive: true });
// });


// ===========Product Side bar Sticky Start ==========
document.addEventListener('DOMContentLoaded', () => {
  const left   = document.querySelector('.media-gallery .sticky-content-container');
  const right  = document.querySelector('.product-column-right');
  const sticky = document.querySelector('.product-form.sticky-content-container');

  if (!left || !right || !sticky) return;

  const EXTRA  = 350;
  const SCROLL_TRIGGER = 350;
  let stickyApplied = false; 

  function recalcHeights() {
    const leftH = left.offsetHeight;
    right.style.minHeight = (leftH + EXTRA) + 'px';
  }

  // function toggleScrollSticky() {
  //   if (window.scrollY >= SCROLL_TRIGGER && !stickyApplied) {
  //     const h = sticky.offsetHeight;
  //     sticky.style.marginTop = `-${h}px`;
  //     right.classList.add('scrolled-past');

  //     requestAnimationFrame(() => {
  //       sticky.style.marginTop = '0px';
  //     });

  //     stickyApplied = true;
  //   }

  //   if (window.scrollY < SCROLL_TRIGGER && stickyApplied) {
  //     right.classList.remove('scrolled-past');
  //     sticky.style.marginTop = '0px';
  //     stickyApplied = false;
  //   }
  // }

  recalcHeights();
  toggleScrollSticky();

  window.addEventListener('resize', () => {
    recalcHeights();
    toggleScrollSticky();
  });

  window.addEventListener('scroll', () => {
    toggleScrollSticky();
  }, { passive: true });
});
// ===========Product Side bar Sticky End ==========



$(document).ready(function () {
    $('.custom-new-opt').on('click', function () {
      $('#sideCartDrawer').addClass('open');
    });

    $('.close-cart').on('click', function () {
      $('#sideCartDrawer').removeClass('open');
    });

    // Optional: click outside to close
    $(document).on('click', function (e) {
      if (
        !$(e.target).closest('#sideCartDrawer').length &&
        !$(e.target).closest('.custom-new-opt').length
      ) {
        $('#sideCartDrawer').removeClass('open');
      }
    });
  });




document.addEventListener('DOMContentLoaded', function () {
  const firstOptionFieldset = document.querySelector('.option-selector[data-is-first-option]');
  const firstOptionInputs = firstOptionFieldset?.querySelectorAll('input.js-option');

  document.querySelectorAll('.option-selector:not([data-is-first-option]) input.js-option').forEach(input => {
    input.addEventListener('change', function () {
      if (!firstOptionInputs) return;

      const isAnyFirstOptionChecked = Array.from(firstOptionInputs).some(input => input.checked);

      if (!isAnyFirstOptionChecked) {
        const firstInput = Array.from(firstOptionInputs).find(input => !input.disabled);
        if (firstInput) {
          firstInput.checked = true;
          firstInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  });
});

 